import { gql } from '../../__generated__/gql'

export const TOGGLE_VOTE_TO_SONG_REQUEST_MUTATION = gql(`
  mutation toggleVoteToSongRequest($songRequestId: Int!) {
    toggleVoteToSongRequest(input: { songRequestId: $songRequestId }) {
      songRequestEntry {
        votesCount
        votedByUser
      }
    }
  }
`)
